import { history, RoutePaths } from 'core/history';
import WorkspaceRoutesContainer from 'modules/Workspace';
import { AuthenticationRedirectComponent } from 'pages/authentication-redirect-component';
import { HallOfOrgsComponent } from 'pages/hall-of-orgs';
import { LegalDocumentsPage } from 'pages/legal-documents';
import { MarketingPage } from 'pages/marketing-page';
import { PageNotFound } from 'pages/page-not-found';
import React from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import { ProtectorMarketingPage } from '../pages/protector-marketing-page';; 
import HierarchyMgtPage from 'pages/hierarchy-mgt/hierarchy-mgt';
import { QuotaMgtPage } from 'pages/quota-mgt/quota-mgt';
import { InviteMembersPage } from 'pages/invite-members/invite-members';
import { TempLegalDocHtml } from 'pages/temp-legal-doc-html';

export const MainRoutes = () => {
  function renderComponent(Component: any, p: any) {
    sessionStorage.setItem('pageIdentifierKey', p.pageIdentifierKey || '');
    return <Component {...p} />;
  }
  return (
    <Router history={history}>
      <Switch>
        <Route
          path={RoutePaths.HOME()}
          exact={true}
          component={MarketingPage}
        />
        
        <Route
          path={RoutePaths.AUTH()}
          exact={true}
          component={AuthenticationRedirectComponent}
        />
        <Route
          path={RoutePaths.ORGS()}
          exact={true}
          component={HallOfOrgsComponent}
        />
        <Route
          path={RoutePaths.LEGAL()}
          render={(p) =>
            renderComponent(LegalDocumentsPage, {
              ...p,
              pageIdentifierKey: 'legal_docs',
            })
          }
        />
        <Route
            path={RoutePaths.PRIVACY()}
            render={(p) =>
              renderComponent(LegalDocumentsPage, {
                ...p,
                pageIdentifierKey: 'legal_docs',
              })
            }
        />
        <Route
            path={RoutePaths.TEMP_PRIVACY()}
            render={(p) =>
              renderComponent(TempLegalDocHtml, {
                ...p,
                pageIdentifierKey: 'legal_docs',
              })
            }
        />
        <Route
            path={RoutePaths.PROTECTOR_MARKETING()}
            exact={true}
            component={ProtectorMarketingPage}
        />
        <Route 
          path={RoutePaths.QUOTA_MANAGEMENT()} exact={true} 
          render={(p) => renderComponent(QuotaMgtPage, { ...p, pageIdentifierKey: 'quota'})} 
        />
        <Route 
          path={RoutePaths.HIERARCHY_MANAGEMENT()} exact={true} 
          render={(p) => renderComponent(HierarchyMgtPage, { ...p, pageIdentifierKey: 'hierarchy' })}
        />
        <Route 
          path={RoutePaths.INVITE_MEMBERS_PAGE()} exact={true} 
          render={(p) => renderComponent(InviteMembersPage, { ...p, pageIdentifierKey: 'invite_members'})} 
        />
        {/* New workspace UI routes */}
        <Route
          exact
          path={['/','/app/*']}
          render={() => <WorkspaceRoutesContainer/>}
        />
        <Route component={PageNotFound} />
      </Switch>
    </Router>
  )
};

export default MainRoutes;
